import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_2 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_3 = { class: "card-title align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "AI Agents", -1)
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end mb-4"
}
const _hoisted_8 = { class: "alert alert-primary d-flex align-items-center mb-5" }
const _hoisted_9 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" AI agents define personality, goals, and optional knowledge base attachment for Messenger auto-reply. Set a default agent in ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("AI 24/7 → AI Settings")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_13 = {
  key: 1,
  class: "text-center py-10 text-muted"
}
const _hoisted_14 = {
  key: 2,
  class: "row g-4"
}
const _hoisted_15 = { class: "card h-100 border hover-elevate-up" }
const _hoisted_16 = { class: "card-body d-flex flex-column" }
const _hoisted_17 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "text-muted fs-7 mb-2"
}
const _hoisted_19 = {
  key: 1,
  class: "text-muted fs-7 mb-2"
}
const _hoisted_20 = {
  key: 2,
  class: "text-muted fs-8 mb-2"
}
const _hoisted_21 = {
  key: 3,
  class: "text-muted fs-8 mb-2"
}
const _hoisted_22 = { class: "text-muted fs-8 mb-4" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Auto follow-up: ")
const _hoisted_24 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_25 = {
  key: 1,
  class: "badge badge-light-secondary"
}
const _hoisted_26 = { class: "mt-auto d-flex flex-wrap gap-2" }
const _hoisted_27 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0,0,0,0.4)"}
}
const _hoisted_28 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = { class: "modal-header" }
const _hoisted_31 = { class: "modal-title" }
const _hoisted_32 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_AiAgentForm = _resolveComponent("AiAgentForm")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      (_ctx.loadError)
        ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.loadError), 1))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: _ctx.embedded ? '' : 'card seq-card mb-5'
      }, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("h3", _hoisted_3, [
                _createVNode("span", _hoisted_4, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Chat6.svg" })
                ]),
                _hoisted_5
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
                }, " New AI Agent ")
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.embedded ? '' : 'card-body py-3'
        }, [
          (_ctx.embedded)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
                }, " New AI Agent ")
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
            ]),
            _createVNode("div", null, [
              _hoisted_10,
              _createVNode(_component_router_link, {
                to: "/settings/ai247-portal?tab=ai",
                class: "fw-bold"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _hoisted_12
            ])
          ]),
          (!_ctx.agents.length)
            ? (_openBlock(), _createBlock("div", _hoisted_13, " No AI agents yet. Create one to customize how AI replies to prospects. "))
            : (_openBlock(), _createBlock("div", _hoisted_14, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.agents, (agent) => {
                  return (_openBlock(), _createBlock("div", {
                    key: agent.id,
                    class: "col-12 col-md-6 col-xl-4"
                  }, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("h4", _hoisted_17, _toDisplayString(agent.name), 1),
                        (agent.knowledgeBaseName)
                          ? (_openBlock(), _createBlock("p", _hoisted_18, " KB: " + _toDisplayString(agent.knowledgeBaseName), 1))
                          : (_openBlock(), _createBlock("p", _hoisted_19, "No knowledge base attached")),
                        (agent.summaryEnabled)
                          ? (_openBlock(), _createBlock("p", _hoisted_20, " Summary every " + _toDisplayString(agent.summaryMinMessages) + " new messages ", 1))
                          : (_openBlock(), _createBlock("p", _hoisted_21, "Conversation summary off")),
                        _createVNode("p", _hoisted_22, [
                          _hoisted_23,
                          (_ctx.isFollowUpEnabled(agent))
                            ? (_openBlock(), _createBlock("span", _hoisted_24, " On (" + _toDisplayString(_ctx.followUpStepCount(agent)) + " step" + _toDisplayString(_ctx.followUpStepCount(agent) === 1 ? "" : "s") + ") ", 1))
                            : (_openBlock(), _createBlock("span", _hoisted_25, "Off"))
                        ]),
                        _createVNode("div", _hoisted_26, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-primary",
                            onClick: ($event: any) => (_ctx.openEdit(agent))
                          }, " Edit ", 8, ["onClick"]),
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-sm btn-light-danger",
                            onClick: ($event: any) => (_ctx.confirmDelete(agent))
                          }, " Delete ", 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
        ], 2)
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _createVNode("h5", _hoisted_31, _toDisplayString(_ctx.editingAgent ? "Edit AI Agent" : "New AI Agent"), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                })
              ]),
              _createVNode("div", _hoisted_32, [
                _createVNode(_component_AiAgentForm, {
                  key: _ctx.editingAgent && _ctx.editingAgent.id ? _ctx.editingAgent.id : 'new',
                  initial: _ctx.editingAgent,
                  saving: _ctx.saving,
                  "submit-label": _ctx.editingAgent ? 'Update agent' : 'Create agent',
                  onSubmit: _ctx.saveAgent,
                  onCancel: _ctx.closeModal
                }, null, 8, ["initial", "saving", "submit-label", "onSubmit", "onCancel"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}